import { $theme } from "../store.js";
import "./themeswitch.css";

class ThemeswitchElement extends HTMLElement {
    #unsub?: Function;

    constructor() {
        super();
    }

    connectedCallback() {
        this.innerHTML = "";

        const label = document.createElement("label");

        const input = document.createElement("input");
        input.type = "checkbox";
        input.onchange = (event) => {
            const evInput = event.target as HTMLInputElement;
            $theme.broadcast(() => (evInput.checked ? "light" : "dark"));
        };

        const icon = document.createElement("bd-icon");
        label.appendChild(input);
        label.appendChild(icon);
        this.appendChild(label);

        this.#unsub = $theme.subscribe((theme) => {
            input.checked = theme === "light";
            icon.setAttribute(
                "value",
                theme === "light" ? "light-bulb-on" : "light-bulb",
            );
        }, true);
    }

    disconnectedCallback() {
        this.#unsub?.();
    }
}

customElements.define("bd-themeswitch", ThemeswitchElement);
